import React, { useState, useEffect, Fragment } from 'react';
import {
    Row, Button,
    UncontrolledDropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle
} from 'reactstrap';
import { Colxx, Separator } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import { gAPI_Business } from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ProductListItem from "./components/ProductListItem";
import AddNewProduct from "./components/AddNewProduct";
import IntlMessages from "../../../../../helpers/IntlMessages";
import Pagination from "../../../../../containers/pages/Pagination";


function Index({ propertyId }) {
    const [buisnessList, setBuisnessList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [visible, setVisible] = useState(false);
    const [orderBy, setOrderBy] = useState({ column: "Title", label: "Name" });
    const [search, setSearch] = useState('');
    const [userpageSizes, setuserpageSizes] = useState([10, 15, 20, 25]);
    const [usercurrentPage, setusercurrentPage] = useState(1);
    const [userSelectedPageSize, setuserSelectedPageSize] = useState(10);
    const [userTotalItems, setuserTotalItems] = useState(0);
    const [userTotalPages, setuserTotalPages] = useState(1);
    const orderOptions = [
        { column: "Title", label: "Name" }
    ]
    useEffect(() => {
        LoadData();
    }, [propertyId, orderBy, search, usercurrentPage, userSelectedPageSize]);

    const LoadData = () => {
        AxiosAPI({
            methhod: 'get',
            url: `${gAPI_Business}?propertyId=${propertyId}&orderBy=${
                orderBy.column}&search=${search}&pageNumber=${usercurrentPage}&pageSize=${userSelectedPageSize}`,
        })
            .then(res => {
                setBuisnessList(res.data);
                setuserTotalItems(res.data.totalItems)
                setuserTotalPages(res.data.totalPages)
                setLoading(false);
            })
            .catch(err => console.log('err', err));
    }

    const toggleModal = () => {
        setVisible(!visible)
    };

    const changeOrderBy = column => {
        setOrderBy(orderOptions.find(
            x => x.column === column
        ))
    };

    const onSearchKey = e => {
        if (e.key === "Enter") {
            setSearch(e.target.value.toLowerCase())
        }
    };

    const changeUserPageSize = size => {
        setuserSelectedPageSize(size)
        setusercurrentPage(1)
    };

    const onChangeUserPage = page => {
        setusercurrentPage(page)
    };

    if (loading) {
        return (
            <div className="loading" />
        );
    }
    const startUserIndex = (usercurrentPage - 1) * userSelectedPageSize;
    const endUserIndex = usercurrentPage * userSelectedPageSize;
    return (
        <Fragment>
            <Row className="app-row survey-app">
                <Colxx xxs="12">
                    <div className="mb-2">
                        <h1>
                            Products & Promotions
              </h1>
                        {!loading && (
                            <Fragment>
                                <div className="text-zero top-right-button-container">
                                    <Button
                                        color="primary"
                                        size="lg"
                                        className="top-right-button mr-1"
                                        onClick={toggleModal}
                                    >
                                        Add New
                                </Button>
                                </div>
                            </Fragment>
                        )}
                    </div>
                    <div className="mb-2">
                        <div className="d-block d-md-inline-block">
                            <UncontrolledDropdown className="mr-1 float-md-left btn-group mb-1">
                                <DropdownToggle caret color="outline-dark" size="xs">
                                    <IntlMessages id="pages.orderby" />
                                    {orderBy.label}
                                </DropdownToggle>
                                <DropdownMenu>
                                    {orderOptions.map((order, index) => {
                                        return (
                                            <DropdownItem
                                                key={index}
                                                onClick={() => changeOrderBy(order.column)}
                                            >
                                                {order.label}
                                            </DropdownItem>
                                        );
                                    })}
                                </DropdownMenu>
                            </UncontrolledDropdown>
                            <div className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top">
                                <input
                                    type="text"
                                    name="keyword"
                                    id="search"
                                    placeholder="Search"
                                    onKeyPress={e => onSearchKey(e)}
                                />
                            </div>
                        </div>
                        <div className="float-md-right">
                            <span className="text-muted text-small mr-1">{`${startUserIndex}-${endUserIndex} of ${userTotalItems} `}</span>
                            <UncontrolledDropdown className="d-inline-block">
                                <DropdownToggle caret color="outline-dark" size="xs">
                                    {userSelectedPageSize}
                                </DropdownToggle>
                                <DropdownMenu right>
                                    {userpageSizes.map((size, index) => {
                                        return (
                                            <DropdownItem
                                                key={index}
                                                onClick={() => changeUserPageSize(size)}
                                            >
                                                {size}
                                            </DropdownItem>
                                        );
                                    })}
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </div>
                    </div>
                </Colxx>
            </Row>
            <Separator className="mb-5" />
            <Row>
                {!loading ? (
                    buisnessList.products.map((item, index) => {
                        return (
                            <ProductListItem
                                key={`product_item_${index}`}
                                item={item}
                                toggleModal={toggleModal}
                                LoadData={LoadData}
                            />
                        );
                    })
                ) : (
                        <div className="loading" />
                    )}
            </Row>

            <Row>
                <Pagination
                    currentPage={usercurrentPage}
                    totalPage={userTotalPages}
                    onChangePage={i => onChangeUserPage(i)}
                />
            </Row>

            <AddNewProduct
                toggleModal={toggleModal}
                formLabel="Create a New Product"
                visible={visible}
                LoadData={LoadData}
            />
        </Fragment>
    );
}

const mapStateToProps = ({ settings }) => {
    const { propertyId } = settings;
    return {
        propertyId,
    };
};

export default injectIntl(connect(mapStateToProps, {})(Index));
